import { Component, OnInit, ElementRef, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';

const Highcharts = require('highcharts/highcharts.src');
import 'highcharts/adapters/standalone-framework.src';

@Component({
    selector: 'highcharts',
    templateUrl: './highcharts.component.html',
    styleUrls: ['./highcharts.component.css']
})
export class HighchartsComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('chart') public chartEl: ElementRef;
    private _chart: any;
    private container: any;

    constructor(private element: ElementRef) {
    }

    ngOnInit() {

        this.container = this.element.nativeElement;

    }

    public ngAfterViewInit() {

        let opts: any = {
            credits: {
                enabled: false
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                },
                line: {
                    marker: {
                        symbol: 'circle'
                    }
                }
            },
            title: {
                text: null,
                x: -20 // center
            },
            xAxis: {
                categories: ['01/28/2017', '01/29/2017', '01/30/2017', '01/31/2017', '02/01/2017', '02/02/2017', '02/03/2017']
            },
            series: [
                {
                    name: 'System Compromise',
                    data: [
                        0, 0, 2, 1, 0, 0, 0
                    ]
                },
                {
                    name: 'Exploitation & Installation',
                    data: [
                        0, 0, 0, 0, 2, 1, 0
                    ]
                },
                {
                    name: 'Delivery & Attack',
                    data: [
                        1, 0, 0, 0, 0, 0, 0
                    ]
                },
                {
                    name: 'Reconnaissance & Probing',
                    data: [
                        0, 0, 0, 0, 0, 3, 0
                    ]
                },
                {
                    name: 'Organizational Insight',
                    data: [
                        2, 0, 0, 0, 0, 2, 0
                    ]
                }
            ]
        };

        if (this.chartEl && this.chartEl.nativeElement) {

            opts.chart = {
                type: 'column',
                renderTo: this.chartEl.nativeElement
            };

            this._chart = new Highcharts.Chart(opts);
        }

    }

    public ngOnDestroy() {

        this._chart.destroy();

    }



}



// WEBPACK FOOTER //
// /app/src/app/components/highcharts/highcharts.component.ts